const MockSuccessIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_7543_1288)">
        <path
          d="M14.6654 4.66666H8.66536V5.99999H14.6654V4.66666ZM14.6654 9.99999H8.66536V11.3333H14.6654V9.99999ZM3.69203 7.33333L1.33203 4.97333L2.27203 4.03333L3.68536 5.44666L6.51203 2.62L7.45203 3.56L3.69203 7.33333ZM3.69203 12.6667L1.33203 10.3067L2.27203 9.36666L3.68536 10.78L6.51203 7.95333L7.45203 8.89333L3.69203 12.6667Z"
          fill="#8B2CE9"
        />
      </g>
      <defs>
        <clipPath id="clip0_7543_1288">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MockSuccessIcon;
